import { UnitOfMeasurement } from "@iventis/domain-model/model/unitOfMeasurement";
import { Body1, Header4, styled } from "@iventis/styles";
import { Content } from "@iventis/translations";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { convertLengthMeasurement } from "@iventis/utilities";
import React from "react";

interface MapObjectMapTooltipSplitLineProps {
    splitLine: { start: number; end: number };
    unitOfMeasurement: UnitOfMeasurement;
}

export function MapObjectMapTooltipSplitLineComponent({ splitLine, unitOfMeasurement }: MapObjectMapTooltipSplitLineProps) {
    const translate = useIventisTranslate();

    return (
        <Container>
            <Header4>{translate(Content.map2.analysis.distance_title)}</Header4>
            <div className="measurements">
                <Body1>{translate(Content.map11.splitLines.tooltipStart)}</Body1>
                <Body1 className="measurement" data-testid="split-line-measurement-start">
                    {convertLengthMeasurement(splitLine.start, unitOfMeasurement)}
                </Body1>
                <Body1>{translate(Content.map11.splitLines.tooltipEnd)}</Body1>
                <Body1 className="measurement" data-testid="split-line-measurement-end">
                    {convertLengthMeasurement(splitLine.end, unitOfMeasurement)}
                </Body1>
            </div>
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 3px;

    .measurements {
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 10px;
    }

    .measurement {
        font-style: italic;
    }
`;
